export default [{
    text: 'полимерный',
    value: 'polymeric'
}, {
    text: 'бетон',
    value: 'concrete'
}, {
    text: 'линолеум',
    value: 'linoleum'
}, {
    text: 'асфальт',
    value: 'asphalt'
}, {
    text: 'плитка',
    value: 'tile'
}, {
    text: 'наливной',
    value: 'selfLeveling'
}, {
    text: 'железнобетонный',
    value: 'reinforcedConcrete'
}, {
    text: 'дерево',
    value: 'wood'
}, {
    text: 'ламинат',
    value: 'laminate'
}];
